module.exports = __webpack_public_path__ + "img/Replace Battery.24b707e7.png";